var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ephemeral-ide", {
    attrs: {
      "accepted-languages": _vm.acceptedLanguages,
      "initial-language": _vm.initialLanguage,
      problem: _vm.problem,
      "should-show-submit-button": _vm.canSubmit,
      "can-run": _vm.canRun,
      "is-embedded": _vm.isEmbedded,
      "initial-theme": _vm.initialTheme,
      "next-submission-timestamp": _vm.nextSubmissionTimestamp,
      "next-execution-timestamp": _vm.nextExecutionTimestamp,
    },
    on: { "execute-run": () => this.$emit("execute-run") },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }